// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#admin-container {
  height: calc(100vh - 80px);
}
#admin-container .selection-container {
  position: absolute;
  right: 5px;
  bottom: 0;
  cursor: pointer;
}
#admin-container .file_upload {
  opacity: 0;
  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  /* IE 5-7 */
  filter: alpha(opacity=0);
  /* Netscape or and older firefox browsers */
  -moz-opacity: 0;
  /* older Safari browsers */
  -khtml-opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
#admin-container .admin-input-block input {
  width: 100%;
  outline: none;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  height: 50px;
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#admin-container .admin-input-block input:disabled {
  background-color: var(--ffff);
}
#admin-container .admin-input-block-dark input {
  width: 100%;
  outline: none;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--4d6c);
  border-radius: 8px;
  height: 50px;
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: var(--4d6c);
  color: var(--ffff);
}
#admin-container .admin-input-block-dark input::placeholder {
  color: var(--dee3);
}
#admin-container .admin-input-block-dark input:disabled {
  background-color: var(--4d6c);
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Admin.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;AAAE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAEJ;AAAE;EACE,UAAA;EAEA,SAAA;EACA,gEAAA;EAEA,WAAA;EACA,wBAAA;EAEA,2CAAA;EACA,eAAA;EAEA,0BAAA;EACA,iBAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAHJ;AAMI;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AAKM;EACE,6BAAA;AAHR;AAQI;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AANN;AAOM;EACE,kBAAA;AALR;AAOM;EACE,6BAAA;AALR","sourcesContent":["#admin-container {\r\n  height: calc(100vh - 80px);\r\n  .selection-container {\r\n    position: absolute;\r\n    right: 5px;\r\n    bottom: 0;\r\n    cursor: pointer;\r\n  }\r\n  .file_upload {\r\n    opacity: 0;\r\n\r\n    /* IE 8 */\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\r\n\r\n    /* IE 5-7 */\r\n    filter: alpha(opacity=0);\r\n\r\n    /* Netscape or and older firefox browsers */\r\n    -moz-opacity: 0;\r\n\r\n    /* older Safari browsers */\r\n    -khtml-opacity: 0;\r\n\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .admin-input-block {\r\n    input {\r\n      width: 100%;\r\n      outline: none;\r\n      display: flex;\r\n      flex-direction: column;\r\n      border: 1px solid var(--dee3);\r\n      border-radius: 8px;\r\n      height: 50px;\r\n      padding: 13px 16px;\r\n      font-size: 14px;\r\n      font-weight: 400;\r\n      font-family: \"f-400\";\r\n      line-height: 19.5px;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      &:disabled {\r\n        background-color: var(--ffff);\r\n      }\r\n    }\r\n  }\r\n  .admin-input-block-dark {\r\n    input {\r\n      width: 100%;\r\n      outline: none;\r\n      display: flex;\r\n      flex-direction: column;\r\n      border: 1px solid var(--4d6c);\r\n      border-radius: 8px;\r\n      height: 50px;\r\n      padding: 13px 16px;\r\n      font-size: 14px;\r\n      font-weight: 400;\r\n      font-family: \"f-400\";\r\n      line-height: 19.5px;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      background: var(--4d6c);\r\n      color: var(--ffff);\r\n      &::placeholder {\r\n        color: var(--dee3);\r\n      }\r\n      &:disabled {\r\n        background-color: var(--4d6c);\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
